import React from 'react';
import { Box, Text, Flex, Modal, ModalOverlay, ModalBody, ModalContent } from '@chakra-ui/react';
import { redirectToNewPage } from '../../global/helpers/global-helpers';
import { LiaHourglassEndSolid } from "react-icons/lia";
import LaunchdeckButton from '../../global/components/helper-components/components/LaunchdeckButton';
import {IoLockOpen } from 'react-icons/io5'


export default function IdleRoomUnlockedModal() {

    return (
      <Modal isOpen={true} closeOnOverlayClick={false} isCentered={true} >
        <ModalOverlay />
        <ModalContent rounded='0.25em' minW={['90%', '90%', '50%', '50%']}  >
          <ModalBody>
            <Flex direction='column' justify='space-around' alignItems='center' w='100%'>
              <Flex justify='space-between' align='center' w='100%' borderBottom='1px solid' borderBottomColor='gray.300'>
                <Flex px='1em' justify='flex-start' align='center'>
                  <Box as={LiaHourglassEndSolid} color='brand.500' boxSize="1.6em" />
                  <Box px='1.5em' py='0.5em' color='brandDark.500'>Idle Room unlocked</Box>
                </Flex>

                {/* <Box pr='1.5em'>
                    <LaunchdeckCloseButton handleCloseModal={() => handleCloseModal()} />
                </Box> */}
              </Flex>

              <Flex direction='column' justify='space-around' alignItems='center' w='100%'>
                <Flex direction='column' position='relative' bg='white' m='auto'>
                  <Flex direction='column' justify='center' align='center' minHeight='70vh' px='2em' w='100%' position='relative'>
                    <DisplayContent  />
                    <Flex justify='flex-end' w='100%' px='1.5em' pb='1em' position='absolute' bottom='0.1em'>
                      
                    </Flex>
                  </Flex>
                </Flex>
              </Flex>

            </Flex>
          </ModalBody>
        </ModalContent>
      </Modal>
    );
}



function DisplayContent() {
  
  return (
    <Flex direction='column' alignItems='center' justify='center' w='100%'>
      <Flex direction='column' alignItems='center' justify='center' w='100%'>
        <Box mb='1em'>
       
               <Box as={IoLockOpen} color='brandDark.500' boxSize="3em" />
        </Box>

        <Box w='100%' fontSize='0.9em' mt='1em' fontWeight='400' lineHeight='1.375em'>
          <Text textAlign='center' mt='0.5em' my={['1em', '0em', '0em', '0em']}>Your draft has been left idle for 60 mins</Text>
          <Text textAlign='center' mt='0.5em' my={['1em', '0em', '0em', '0em']}>We've unlocked it to allow other Room Administrators to edit it</Text>
        </Box>

        <Box mt='3em'>
          <LaunchdeckButton bg='brand.500' color='white' px='2em' onClick={() => redirectToNewPage(`/vault`)} label='OK, got it' />
        </Box>
      </Flex>
    </Flex>
  )
}
